/* eslint-disable no-plusplus */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import { Document, Page } from 'react-pdf';

import { IDeliveryNote } from 'commons/types';
import { DNPrintTemplateComponent } from 'pages/delivery-note/dn-detail/print-components/DNPrintTemplate.component';
import { GetSPDocumentURLWithContentBase64 } from 'services/apis/SwipeRxWmsApiPackingTask/interfaces';

import { IInvoiceMappedData } from '../../interfaces';
import { InvoicePrintTemplateComponent } from '../invoice-template';

const InvoiceSPPrintTemplate: React.FC = () => {
  document.body.className = 'print-template';

  const [data, setData] = useState<IInvoiceMappedData>();
  const [spDocumentBase64, setSpDocumentBase64] =
    useState<GetSPDocumentURLWithContentBase64>();
  const [pdfMaxPage, setPdfMaxPage] = useState<number>(0);
  const [deliveryNote, setDeliveryNote] = useState<IDeliveryNote | null>(null);
  const [invoicePageBreak, setInvoicePageBreak] = useState<React.JSX.Element[]>(
    [],
  );
  const [dnPageBreak, setDnPageBreak] = useState<React.JSX.Element[]>([]);
  const [invoicePageNumber, invoiceSetPageNumber] = useState<number>(0);
  // to handle break space between invoice and dn template
  const setInvoiceMaxPageNumber = (pageNumber: number) => {
    // set dn page break
    const pageBreak: React.JSX.Element[] = [];
    for (let i = 0; i < pageNumber - 1; i++) {
      pageBreak.push(<div style={{ pageBreakAfter: 'always' }} />);
    }
    setInvoicePageBreak(pageBreak);
    invoiceSetPageNumber(pageNumber);
  };

  // to handle break space between DNs
  const setDnPageBreakFromPageNumber = (pageNumber: number) => {
    // set dn page break
    const pageBreak: React.JSX.Element[] = [];
    // eslint-disable-next-line no-plusplus
    for (let i = 0; i < pageNumber - 1; i++) {
      pageBreak.push(<div style={{ pageBreakAfter: 'always' }} />);
    }
    setDnPageBreak(pageBreak);
  };

  useEffect(() => {
    // one-time access; remove localstorage after
    const storageData = localStorage.getItem('invoice');
    const storageSpDocumentData = localStorage.getItem('esp-content-base64');
    const storageDeliveryNote = localStorage.getItem('delivery-note');

    if (storageData) {
      setData(JSON.parse(storageData));
      localStorage.removeItem('invoice');
    }

    if (storageSpDocumentData) {
      setSpDocumentBase64(JSON.parse(storageSpDocumentData));
      localStorage.removeItem('esp-content-base64');
    }

    if (storageDeliveryNote) {
      try {
        setDeliveryNote(JSON.parse(storageDeliveryNote));
      } catch {
        setDeliveryNote(null);
      }
      localStorage.removeItem('delivery-note');
    }
  }, []);

  // early return
  if (!data) return <div />;

  return (
    <>
      <InvoicePrintTemplateComponent
        data={data}
        setMaxPageNumber={setInvoiceMaxPageNumber}
      />
      {deliveryNote && (
        <>
          {invoicePageBreak}
          {/* handle anomaly case when invoice template page only 1 */}
          {invoicePageNumber === 1 && (
            <div style={{ pageBreakAfter: 'always' }} />
          )}
          <DNPrintTemplateComponent
            data={deliveryNote}
            copyNumber={0}
            offsetStart={invoicePageNumber}
            setDnPageBreakFromPageNumber={setDnPageBreakFromPageNumber}
          />
          {dnPageBreak}
          <DNPrintTemplateComponent
            data={deliveryNote}
            copyNumber={1}
            offsetStart={invoicePageNumber}
          />
        </>
      )}

      {spDocumentBase64 &&
        spDocumentBase64.url &&
        !spDocumentBase64.url.includes('.pdf') && (
          <img
            src={spDocumentBase64.url}
            alt="tst"
            style={{ width: '100%', height: '99vh' }}
          />
        )}

      {spDocumentBase64 &&
        spDocumentBase64.url &&
        spDocumentBase64.url.includes('.pdf') && (
          <Document
            file={`data:application/pdf;base64,${spDocumentBase64.documentBase64}`}
            onLoadSuccess={({ numPages }) => setPdfMaxPage(numPages)}
            onLoadError={(error) => console.log('onLoadError', error)}
          >
            {pdfMaxPage &&
              Array.from({ length: pdfMaxPage }, (_, page) => (
                <Page
                  pageNumber={page + 1}
                  width={800}
                  renderTextLayer={false}
                  renderAnnotationLayer={false}
                />
              ))}
          </Document>
        )}
    </>
  );
};

export default InvoiceSPPrintTemplate;
